// extracted by mini-css-extract-plugin
export default {"tabsContainer":"FilterTabs_tabsContainer__n8hMB","tabButton":"FilterTabs_tabButton__SX-sO","active":"FilterTabs_active__b2S1v"};